import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import QRCode from "qrcode.react";
import { IoCopyOutline } from "react-icons/io5";
import { MdDone } from "react-icons/md";
import { IoMdClose } from "react-icons/io";
import html2canvas from "html2canvas";
import { FaLink } from "react-icons/fa6";
import { RiDownloadLine } from "react-icons/ri";
import ImageLoading from "../../../components/ImageLoading";
import SuccessImage from "../../../images/sidebar/SuccessImage";
// import Lottie from "react-lottie";
// import animation from "../Revoke/animation.json";

const InitiateInvokeModal = ({
  link,
  cancelFunction,
  selectedItems,
  invocationState,
  setReRender,
  reRender,
  setReadOnly,
}) => {
  const [copyText, setCopyText] = useState(true);
  const [clickDownload, setClickDownload] = useState(false);
  const qrRef = useRef();
  const [succesState, setSuccesState] = useState(false);
  const [password, setPassword] = useState("");
  const [invokeNow, setInvokeNow] = useState(false);
  const [error, setError] = useState("");
  const [imageLoading, setImageLoading] = useState(false);

  const handleBulkInvoke = async () => {
    // console.log(selectedItems);
    setImageLoading(true);
    const token = localStorage.getItem("token");
    try {
      const options = {
        url: `${process.env.REACT_APP_URL}/lender/v1/invoke/initiate_bulk_invoke`,
        method: "POST",
        headers: { Authorization: token },
        data: {
          order_nos: selectedItems,
        },
      };
      const res = await axios(options);
      // console.log(res);
      if (res.data.message === "Invoke initiated successfully.") {
        setSuccesState(true);
        setReRender(!reRender);
        setTimeout(() => {
          cancelFunction(false);
        }, 3000);

        console.log(res.data.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setImageLoading(false);
    }
  };
  const handleBulkInvokeInstant = async () => {
    // console.log(selectedItems);
    setImageLoading(true);
    const token = localStorage.getItem("token");
    try {
      const options = {
        url: `${process.env.REACT_APP_URL}/lender/v1/invoke/instant_bulk_invoke`,
        method: "POST",
        headers: { Authorization: token },
        data: {
          confirm_password: password,
          order_nos: selectedItems,
        },
      };
      const res = await axios(options);
      // console.log(res);
      if (res.data.message === "Invoked successfully.") {
        setInvokeNow(true);
        setReRender(!reRender);
        setReadOnly(false);
        setTimeout(() => {
          cancelFunction(false);
        }, 3000);

        console.log(res.data.message);
      }
    } catch (error) {
      console.log(error.response.data.message);
      setError(error.response.data.message);
    } finally {
      setImageLoading(false);
    }
  };
  // useEffect(() => {
  //   console.log(password);
  // }, [password]);
  useEffect(() => {
    setReadOnly(true);
    return () => {
      setReadOnly(false);
    };
  }, []);
  return (
    <div className="overlay z-50">
      <div
        className={`modal !w-[360px]  !justify-normal  relative !p-0 !text-left ${
          invocationState === "initiatedInvocation"
            ? "!h-[260px]"
            : "!items-center !h-[155px]"
        } ${error ? " !h-[270px]" : ""} `}
      >
        {!succesState &&
          !invokeNow &&
          invocationState !== "initiatedInvocation" && (
            <>
              {imageLoading && (
                <div className="w-full h-full flex items-center justify-center">
                  <ImageLoading />
                </div>
              )}
              {!imageLoading && (
                <>
                  <p className=" text-base font-semibold mt-[24px]">
                    Do you want to initiate the invocation?
                  </p>
                  <p className=" text-xs text-[#848484] mt-3 ">
                    Invoke process will take 5 working days
                  </p>

                  <div className=" mt-4 flex justify-center ">
                    <button
                      className=" rounded px-4 py-[3px] border border-[#00394d] text-sm font-semibold text-[#00394d] h-[44px] mr-3"
                      onClick={() => {
                        setReadOnly(false);
                        cancelFunction(false);
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      onClick={handleBulkInvoke}
                      className=" rounded px-4 py-[3px]  bg-[#00394d] text-sm font-semibold text-white h-[44px]"
                    >
                      Yes, Initiate Invoke
                    </button>
                  </div>
                </>
              )}
            </>
          )}
        {!succesState &&
          !invokeNow &&
          invocationState === "initiatedInvocation" && (
            <>
              {imageLoading && (
                <div className="w-full h-full flex items-center justify-center">
                  <ImageLoading />
                </div>
              )}
              {!imageLoading && (
                <div>
                  <p className=" text-base font-semibold mt-[24px] pl-6">
                    Invoke Now
                  </p>
                  <p className=" text-xs font-medium mt-[12px] pl-6 text-[#848484] mb-4">
                    To invoke now, please enter the password.
                  </p>
                  <div className=" pr-6">
                    <label className=" text-sm font-medium pl-6">
                      Password
                    </label>
                    <input
                      type="password"
                      autoComplete="new-password"
                      className=" hidden"
                    />
                    <input
                      value={password}
                      autoComplete="new-password"
                      onChange={(e) => {
                        setPassword(e.target.value);
                        setError("");
                      }}
                      type="password"
                      placeholder="Password"
                      className=" border border-[#656565] rounded text-xs font-medium w-[90%] h-[44px] pl-2 mt-2 ml-6 mr-6 focus:outline-none"
                    ></input>
                    {error && (
                      <p className=" ml-[25px] font-normal mt-1  text-xs text-red-500">
                        {error}
                      </p>
                    )}
                  </div>

                  <div className=" mt-6 flex justify-center ">
                    <button
                      className=" rounded w-[110px] px-4 py-[3px] border border-[#00394d] text-sm font-semibold text-[#00394d] h-[44px] mr-3"
                      onClick={() => cancelFunction(false)}
                    >
                      Cancel
                    </button>
                    <button
                      onClick={handleBulkInvokeInstant}
                      className=" w-[110px] rounded px-4 py-[3px]  bg-[#00394d] text-sm font-semibold text-white h-[44px]"
                    >
                      Invoke now
                    </button>
                  </div>
                </div>
              )}
            </>
          )}
        {succesState && (
          <div className=" w-full h-full flex justify-center flex-col items-center">
            {/* <Lottie
              animationData={animation}
              options={defaultOptions}
              height={70}
              width={70}
            /> */}
            <SuccessImage />
            <p className=" font-bold  text-base mt-2">
              Invoke initiate, successful!
            </p>
          </div>
        )}
        {invokeNow && (
          <div className=" w-full h-full flex justify-center flex-col items-center">
            {/* <Lottie
              animationData={animation}
              options={defaultOptions}
              height={70}
              width={70}
            /> */}
            <SuccessImage />
            <p className=" font-bold  text-base mt-2">
              Invoke now, successful!
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default InitiateInvokeModal;
